/**
 * Hook para ler links gerenciados pelo admin em runtime.
 *
 *   const href = useSiteLink("link.header.certificacao", DEFAULT_URL);
 *
 * Se o admin publicar um novo valor via /admin/painel (cartão de links
 * gerenciáveis), o hook devolve o valor novo no próximo hydration
 * (~30s de TTL do cache de overrides).
 */
import { useEffect, useState } from "react";

import { ensureOverridesLoaded, getOverride } from "@/lib/site-overrides";
import { officialProductLink } from "@/lib/checkout/product-redirects";

export function useSiteLink(key: string, fallback: string): string {
  const [value, setValue] = useState<string>(() => {
    const v = getOverride<{ url?: string }>(key);
    return officialProductLink(v?.url || fallback);
  });

  useEffect(() => {
    let alive = true;
    void ensureOverridesLoaded().then(() => {
      if (!alive) return;
      const v = getOverride<{ url?: string }>(key);
      setValue(officialProductLink(v?.url || fallback));
    });
    return () => {
      alive = false;
    };
  }, [key, fallback]);

  return value;
}
